import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WowSetting } from '@techmore/wow';


@Component({
  selector: 'app-wow-control-panel',
  templateUrl: './wow-control-panel.component.html',
  styleUrls: ['./wow-control-panel.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => WowControlPanelComponent),
    multi: true
  }]
})
export class WowControlPanelComponent implements ControlValueAccessor {
  @Input() name: string;
  wowSettingData = {
    turnOn: [true, false],
    animate: [
      'slideInDown', 'slideInLeft', 'slideInRight', 'slideInUp',
      'bounce', 'bounceIn', 'bounceInDown', 'bounceInLeft', 'bounceInRight', 'bounceInUp',
      'fadeInDown', 'fadeInLeft', 'fadeInRight', 'fadeInUp',
    ]
  };
  wowSetting: WowSetting = {
    turnOn: false,
    animate: 'fadeInUp',
  };
  // 用來接收 registerOnChange 和 onTouched 傳入的方法
  onChange: (value) => {};
  onTouched: () => {};

  // 元件內必須找一個時機觸發 change 方法
  notifyValueChange() {
    this.onChange({
      turnOn: this.wowSetting.turnOn,
      animate: this.wowSetting.animate,
    });
  }

  constructor() { }

  writeValue(obj: any): void {
    if (obj) {
      this.wowSetting = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void { }

}
